import modalStyle from "../../modal.module.scss";

import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

import React, { useEffect } from 'react';
import { Typography, Button, Box } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { adoptionSourceType } from "../../../const";

const AdoptionTitle = (props) => {
  const { adoptionSource, currentStep, totalSteps, closeOpenModal, disabledBtn } = props;

  // State

  // Method

  // Side effect
  useEffect(() => {
  }, []);

  const isLastStep = currentStep === totalSteps;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography color="#707ca8" fontWeight="600" fontSize="20px">
          {
            adoptionSource === adoptionSourceType.byRow ? (
              <FormattedMessage id="device.adoption.byRow.title" defaultMessage="Device Adoption" />
            ) : adoptionSource === adoptionSourceType.byCheckboxWithIpSettings ? (
              <FormattedMessage id="device.adoption.byCheckboxWithIpSettings.title" defaultMessage="IP Settings" />
            ) : adoptionSource === adoptionSourceType.byCheckboxWithAuthenticate ? (
              <FormattedMessage id="device.adoption.byCheckboxWithAuthenticate.title" defaultMessage="Authentication" />
            ) : (
              <FormattedMessage id="device.adoption.byCheckboxWithAdoption.title" defaultMessage="Device Adoption" />
            )
          }
        </Typography>
        <Button
          onClick={() => {
            if (isLastStep && disabledBtn) {
              return;
            }
            closeOpenModal();
          }}
          className={`${isLastStep && disabledBtn ? modalStyle['disabled_closeBtn'] : ''}`}
          sx={{
            marginRight: "-20px",
            backgroundColor: "transparent",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <CloseIcon />
        </Button>
      </Box>
    </>
  );
}

export default AdoptionTitle;